import {
    URL_HELP,
  requestOptionsGet,
  requestOptionsPost,
  // requestOptionsPut,
  getJSON,
  // URL_DOMAIN_SUPERADMIN,
} from "./globals";

const eInvoiceSalesExcluded = async (jsonBody) => {
  requestOptionsPost.body = jsonBody;
  return fetch(
    URL_HELP + "invoice/electronic-invoice/sales-excluded",
    requestOptionsPost
  ).then(getJSON);
};

const createEInvoiceForCustomer = async (jsonBody) => {
  requestOptionsPost.body = jsonBody;
  return fetch(
    URL_HELP + "invoice/electronic-invoice/electronic-invoice-consumer",
    requestOptionsPost
  ).then(getJSON);
};

// Builds its own options object instead of mutating the shared
// `requestOptionsPost` from globals.js, which every other service also writes
// to. Checks response.ok before parsing: a 504 returns HTML, and piping that
// straight into .json() is what produced the endless spinner the client saw.
//
// An unreadable body is reported as OUTCOME UNKNOWN, not as a failure. A
// request killed mid-flight can still have issued invoices, so the caller must
// never advance its cursor past a chunk that ended this way.
const createMassiveEInvoice = async (jsonBody) => {
  const response = await fetch(
    URL_HELP + "invoice/electronic-invoice/electronic-invoice-organization",
    {
      method: "POST",
      headers: requestOptionsPost.headers,
      redirect: "follow",
      body: jsonBody,
    }
  );

  if (!response.ok) {
    const error = new Error(`El servidor respondió ${response.status}`);
    error.status = response.status;
    error.outcomeUnknown = response.status === 504 || response.status === 502;
    throw error;
  }

  try {
    return await response.json();
  } catch (parseError) {
    const error = new Error(
      "La respuesta del servidor llegó incompleta. No se sabe si se generaron facturas en este bloque."
    );
    error.outcomeUnknown = true;
    throw error;
  }
};

const previewMassiveEInvoice = async (jsonObj) => {
  const { start_date, end_date, fk_organization, excluded_sale_points } = jsonObj;
  return fetch(
    URL_HELP +
      "invoice/electronic-invoice/invoice-summary-excluded?" +
      `fk_organization=${fk_organization}` +
      `&start_date=${start_date}` +
      `&end_date=${end_date}` +
      `&excluded_sale_points=[${excluded_sale_points}]`,
    requestOptionsGet
  )
};


const eInvoiceSummaryAllOrganization = async (fkOrganization) => {
  return fetch(
    URL_HELP +
      "invoice/electronic-invoice/last-invoice-summary?fk_organization=" +
      fkOrganization,
    requestOptionsGet
  ).then(getJSON);
};

export {
  createEInvoiceForCustomer,
  createMassiveEInvoice,
  eInvoiceSummaryAllOrganization,
  previewMassiveEInvoice,
  eInvoiceSalesExcluded
};
